import { useState } from 'react';
import { OtpForm } from './otp-form.tsx';
import { PhoneForm } from './phone-form.tsx';

export const AuthorizationForm = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const [phone, setPhone] = useState<string | null>(null);
  return phone ? (
    <OtpForm
      phone={phone}
      onChangePhone={() => setPhone(null)}
      onSuccess={() => onSuccess?.()}
    />
  ) : (
    <PhoneForm onSuccess={setPhone} />
  );
};
